<template>
  <div class="c-navbar-placehoder">
    <div
      :class="['c-navbar', { 'is-border': border }, { 'is-fixed': fixed }]"
      :style="{ zIndex: zIndex }"
    >
      <div class="c-navbar-back">
        <img
          src="@/assets/image/c-navbar-back.png"
          alt=""
          @click="$router.back()"
        />
      </div>
      <div class="c-navbar-title">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CNavbar',
  props: {
    title: String,
    zIndex: {
      type: [String, Number],
      default: 30
    },
    border: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less" scoped>
.c-navbar {
  display: flex;
  height: 90px;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  background-color: #ffffff;
  padding: 0 100px;
  position: relative;
  &.is-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
  &.is-border {
    border-bottom: 1px solid #f2f2f2;
  }
  &-placehoder {
    height: 90px;
  }
  &-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &-back {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    cursor: pointer;
    img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
